import React from 'react';
import * as S from './styles';
import { isNullUndefined } from '@/main/services/utils';
import image6 from '@/main/assets/images/homepage/asset@3x.png';
import ButtonDemo from '../../components/buttonDemo/buttonDemo';

type IImageProps = {
  clipBorderImage?: S.IClipBorderImage;
  height?: string;
  width?: string;
};
interface ITextImageProps {
  backgroundImage: string;
  title: string;
  description: string;
  positionImage: 'left' | 'right';
  icon?: React.ReactNode;
  imageProps?: IImageProps;
  idImage?: string;
  showButton?: boolean;
  subTitle?: string;
}

function TextImageInsurer({
  backgroundImage,
  description,
  title,
  positionImage,
  icon,
  imageProps,
  idImage,
  showButton,
  subTitle
}: ITextImageProps) {
  if (isNullUndefined(showButton)) showButton = false;
  return (
    <S.Container $positionImage={positionImage}>
      <S.AreaText data-aos='fade-up' >
        {!isNullUndefined(subTitle) && <S.SubTitleSection>{subTitle}</S.SubTitleSection>}
        {!isNullUndefined(icon) && <S.Icon>{icon}</S.Icon>}
        <S.Title>
          {title}
          <br />
          {showButton && <ButtonDemo />}
        </S.Title>
        <S.Description>{description}</S.Description>
      </S.AreaText>
      <S.AreaImage $positionImage={positionImage} data-aos='fade-up' data-aos-delay='300'>
        <S.Image
          id={idImage}
          $clipBorderImage={imageProps?.clipBorderImage}
          src={backgroundImage}
          $height={imageProps?.height}
          $width={imageProps?.width}
          alt=""
        />
        <S.ImageLine src={image6} />
      </S.AreaImage>
    </S.Container>
  );
}

export default TextImageInsurer;
